<template>
  <div>
    <music-form :id="this.id.toString()" v-on:success="success"></music-form>
  </div>
</template>

<script>

import { MusicService } from '@/common/services/music.service';

export default {
  name: 'MusicEdit',
  components: {
    MusicForm: () => import('@/views/music/form.vue'),
  },
  props: [
    'id',
  ],
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
    success(id) {
      this.$router.push({ name: 'MusicShow', params: { id: id } });
    },
  },
};

</script>

<style lang="scss" scoped>

</style>
